import { Stack, Typography } from "@mui/material";
import * as Sentry from "@sentry/browser";
import VidletLogo from "components/VidletLogo";
import { Component } from "react";

export default class ErrorBoundary extends Component {
  state: {
    hasError: boolean;
  };

  props: {
    children: React.ReactNode;
  };

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    const sentryIsInitialized = process.env.REACT_APP_SENTRY_DSN != undefined;
    return { hasError: sentryIsInitialized ? true : false };
  }

  componentDidCatch(error) {
    Sentry.captureException(error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Stack
          spacing={3}
          sx={{
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100%",
          }}
        >
          <VidletLogo style={{ transform: "scale(2)" }} />
          <Typography variant="h3">Something went wrong!</Typography>
          <Typography variant="h5">Please try again later</Typography>
        </Stack>
      );
    }

    return this.props.children;
  }
}
